import React from 'react'

export const TexMuted = (props) => (
    <p className="tex-muted">{ props.children }</p>
)
